import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import MainNavigation from '../../components/ui/MainNavigation';
import Footer from '../home-page/components/Footer';

const PrivacyPolicy = () => {
  const [openSections, setOpenSections] = useState({});

  const toggleSection = (sectionId) => {
    setOpenSections(prev => ({
      ...prev,
      [sectionId]: !prev?.[sectionId]
    }));
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <MainNavigation />
      
      <main className="flex-1 py-8 md:py-12 lg:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="mb-8 md:mb-12">
            <Link 
              to="/" 
              className="inline-flex items-center space-x-2 text-sm text-muted-foreground hover:text-primary transition-smooth mb-4"
            >
              <Icon name="ArrowLeft" size={16} />
              <span>Back to Home</span>
            </Link>
            
            <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground mb-4">
              Privacy Policy
            </h1>
            
            <p className="font-body text-base text-muted-foreground">
              <strong>Effective Date:</strong> February 11,2026
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-4">
            {/* Information We Collect */}
            <div className="bg-card border border-border rounded-lg overflow-hidden">
              <button
                onClick={() => toggleSection('information-collect')}
                className="w-full p-6 flex items-center justify-between hover:bg-muted/50 transition-colors"
              >
                <div className="flex items-center space-x-2">
                  <Icon name="Database" size={24} className="text-primary" />
                  <h2 className="font-heading font-bold text-2xl text-foreground">Information We Collect</h2>
                </div>
                <Icon 
                  name="ChevronDown" 
                  size={24} 
                  className={`text-muted-foreground transition-transform duration-200 ${openSections?.['information-collect'] ? 'rotate-180' : ''}`}
                />
              </button>
              {openSections?.['information-collect'] && (
                <div className="px-6 pb-6">
                  <ul className="space-y-3 ml-6">
                    <li className="font-body text-base text-muted-foreground flex items-start space-x-2">
                      <Icon name="Circle" size={8} className="mt-2 flex-shrink-0" />
                      <span>Name, email, phone number</span>
                    </li>
                    <li className="font-body text-base text-muted-foreground flex items-start space-x-2">
                      <Icon name="Circle" size={8} className="mt-2 flex-shrink-0" />
                      <span>Payment data (processed by third parties)</span>
                    </li>
                    <li className="font-body text-base text-muted-foreground flex items-start space-x-2">
                      <Icon name="Circle" size={8} className="mt-2 flex-shrink-0" />
                      <span>Listing and booking data</span>
                    </li>
                    <li className="font-body text-base text-muted-foreground flex items-start space-x-2">
                      <Icon name="Circle" size={8} className="mt-2 flex-shrink-0" />
                      <span>Device and usage data</span>
                    </li>
                  </ul>
                </div>
              )}
            </div>

            {/* How We Use Information */}
            <div className="bg-card border border-border rounded-lg overflow-hidden">
              <button
                onClick={() => toggleSection('use-information')}
                className="w-full p-6 flex items-center justify-between hover:bg-muted/50 transition-colors"
              >
                <div className="flex items-center space-x-2">
                  <Icon name="Settings" size={24} className="text-primary" />
                  <h2 className="font-heading font-bold text-2xl text-foreground">How We Use Information</h2>
                </div>
                <Icon 
                  name="ChevronDown" 
                  size={24} 
                  className={`text-muted-foreground transition-transform duration-200 ${openSections?.['use-information'] ? 'rotate-180' : ''}`}
                />
              </button>
              {openSections?.['use-information'] && (
                <div className="px-6 pb-6">
                  <ul className="space-y-3 ml-6">
                    <li className="font-body text-base text-muted-foreground flex items-start space-x-2">
                      <Icon name="Circle" size={8} className="mt-2 flex-shrink-0" />
                      <span>Operate and improve the platform</span>
                    </li>
                    <li className="font-body text-base text-muted-foreground flex items-start space-x-2">
                      <Icon name="Circle" size={8} className="mt-2 flex-shrink-0" />
                      <span>Facilitate transactions</span>
                    </li>
                    <li className="font-body text-base text-muted-foreground flex items-start space-x-2">
                      <Icon name="Circle" size={8} className="mt-2 flex-shrink-0" />
                      <span>Prevent fraud</span>
                    </li>
                    <li className="font-body text-base text-muted-foreground flex items-start space-x-2">
                      <Icon name="Circle" size={8} className="mt-2 flex-shrink-0" />
                      <span>Comply with legal obligations</span>
                    </li>
                  </ul>
                </div>
              )}
            </div>

            {/* Data Sharing */}
            <div className="bg-card border border-border rounded-lg overflow-hidden">
              <button
                onClick={() => toggleSection('data-sharing')}
                className="w-full p-6 flex items-center justify-between hover:bg-muted/50 transition-colors"
              >
                <div className="flex items-center space-x-2">
                  <Icon name="Share2" size={24} className="text-primary" />
                  <h2 className="font-heading font-bold text-2xl text-foreground">Data Sharing</h2>
                </div>
                <Icon 
                  name="ChevronDown" 
                  size={24} 
                  className={`text-muted-foreground transition-transform duration-200 ${openSections?.['data-sharing'] ? 'rotate-180' : ''}`}
                />
              </button>
              {openSections?.['data-sharing'] && (
                <div className="px-6 pb-6">
                  <p className="font-body text-base text-muted-foreground leading-relaxed">
                    We may share information between Owners and Renters to complete transactions. We do NOT sell personal information.
                  </p>
                </div>
              )}
            </div>

            {/* State Privacy Rights */}
            <div className="bg-card border border-border rounded-lg overflow-hidden">
              <button
                onClick={() => toggleSection('state-privacy')}
                className="w-full p-6 flex items-center justify-between hover:bg-muted/50 transition-colors"
              >
                <div className="flex items-center space-x-2">
                  <Icon name="Shield" size={24} className="text-primary" />
                  <h2 className="font-heading font-bold text-2xl text-foreground">State Privacy Rights</h2>
                </div>
                <Icon 
                  name="ChevronDown" 
                  size={24} 
                  className={`text-muted-foreground transition-transform duration-200 ${openSections?.['state-privacy'] ? 'rotate-180' : ''}`}
                />
              </button>
              {openSections?.['state-privacy'] && (
                <div className="px-6 pb-6">
                  <p className="font-body text-base text-muted-foreground leading-relaxed">
                    Residents of California, Colorado, Virginia, Connecticut, Utah, Nevada, and Washington may have additional privacy rights under applicable state law.
                  </p>
                </div>
              )}
            </div>

            {/* Contact */}
            <div className="bg-card border border-border rounded-lg overflow-hidden">
              <button
                onClick={() => toggleSection('contact')}
                className="w-full p-6 flex items-center justify-between hover:bg-muted/50 transition-colors"
              >
                <div className="flex items-center space-x-2">
                  <Icon name="Mail" size={20} className="text-primary" />
                  <h2 className="font-heading font-bold text-xl text-foreground">Contact</h2>
                </div>
                <Icon 
                  name="ChevronDown" 
                  size={24} 
                  className={`text-muted-foreground transition-transform duration-200 ${openSections?.['contact'] ? 'rotate-180' : ''}`}
                />
              </button>
              {openSections?.['contact'] && (
                <div className="px-6 pb-6">
                  <div className="space-y-2">
                    <p className="font-body text-sm text-foreground">
                      Draggin Trailers LLC<br />
                      Wisconsin, USA<br />
                      <a href="mailto:Draggintrailers@gmail.com" className="text-primary hover:underline">
                        Draggintrailers@gmail.com
                      </a>
                    </p>
                  </div>
                </div>
              )}
            </div>

            {/* Acceptance Notice */}
            <div className="bg-muted/30 border border-border rounded-lg p-6 text-center">
              <Icon name="FileText" size={32} className="text-primary mx-auto mb-3" />
              <p className="font-body text-sm text-muted-foreground">
                By using the Draggin Trailers platform, you acknowledge that you have read and understood this Privacy Policy.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;